import Vue from "vue";
import Vuex from "vuex";
import { Howl, Howler } from "howler";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    numScenes: 9,
    currentScene: 1,
    beginButton: true,
    muted: false,
    trackTime: 0,
    trackInterval: null,
    buttonLabel: "Listen",
    audio: {
      scene1: new Howl({
        src: ["audio/scene-01.mp3"],
        html5: true
      }),
      scene2: new Howl({
        src: ["audio/scene-02.mp3"],
        html5: true
      }),
      scene3: new Howl({
        src: ["audio/scene-03.mp3"],
        html5: true
      }),
      scene4: new Howl({
        src: ["audio/scene-04.mp3"],
        html5: true
      }),
      scene5: new Howl({
        src: ["audio/scene-05.mp3"],
        html5: true
      }),
      scene6: new Howl({
        src: ["audio/scene-07.mp3"],
        html5: true
      }),
      scene7: new Howl({
        src: ["audio/scene-09.mp3"],
        html5: true
      }),
      scene8: new Howl({
        src: ["audio/scene-10.mp3"],
        html5: true
      }),
      scene9: new Howl({
        src: ["audio/scene-11.mp3"],
        html5: true
      }),
      listen1: new Howl({
        src: ["audio/scene-06.mp3"],
        html5: true
      }),
      listen2: new Howl({
        src: ["audio/scene-08.mp3"],
        html5: true
      }),
      swoosh: new Howl({
        src: ["audio/swoosh.mp3"],
        html5: true
      })
    }
  },
  mutations: {
    PREVIOUS_SCENE(state) {
      state.currentScene--;
    },
    NEXT_SCENE(state) {
      state.currentScene++;
    },
    END(state) {
      state.currentScene = 1;
    },
    HIDE_BEGIN_BUTTON(state) {
      state.beginButton = false;
    },
    MUTE(state) {
      state.muted = true;
    },
    UNMUTE(state) {
      state.muted = false;
    },
    RESET_TRACK_TIME(state) {
      state.trackTime = 0;
    },
    SET_BUTTON_LABEL(state, payload) {
      state.buttonLabel = payload;
    },
    RESET_TRACK_INTERVAL(state) {
      clearInterval(state.trackInterval);
      state.trackInterval = setInterval(() => {
        state.trackTime += 0.5;
        if (state.audio.swoosh.playing()) {
          state.buttonLabel = "Pause";
        } else {
          state.buttonLabel = "Listen";
        }
      }, 500);
    },
    CLEAR_TRACK_INTERVAL(state) {
      clearInterval(state.trackInterval);
    }
  },
  actions: {
    begin({ state, commit }) {
      commit("HIDE_BEGIN_BUTTON");
      state.audio.scene1.play();
      commit("RESET_TRACK_INTERVAL");
      commit("RESET_TRACK_TIME");
    },
    previousScene({ state, commit, dispatch }) {
      if (state.currentScene > 1) {
        commit("PREVIOUS_SCENE");
      }
      dispatch("playAudioByScene");
    },
    nextScene({ state, commit, dispatch }) {
      if (state.currentScene < state.numScenes) {
        commit("NEXT_SCENE");
      } else {
        commit("END");
      }
      dispatch("playAudioByScene");
    },
    toggleMute({ state, commit }) {
      if (state.muted) {
        Howler.mute(false);
        commit("UNMUTE");
      } else {
        Howler.mute(true);
        commit("MUTE");
      }
    },
    stopAllAudio({ state, commit }) {
      Object.keys(state.audio).forEach(key => {
        state.audio[key].stop();
      });
      commit("CLEAR_TRACK_INTERVAL");
      commit("RESET_TRACK_TIME");
    },
    playAudioByScene({ state, commit, dispatch }) {
      dispatch("stopAllAudio");
      if (typeof state.audio[`scene${state.currentScene}`] !== "undefined") {
        state.audio[`scene${state.currentScene}`].play();
        commit("RESET_TRACK_INTERVAL");
        commit("RESET_TRACK_TIME");
      }
    },
    playAudioByName({ state }, name) {
      if (typeof state.audio[name] !== "undefined") {
        state.audio[name].play();
      }
    },
    toggleAudioByName({ state }, name) {
      if (typeof state.audio[name] !== "undefined") {
        if (state.audio[name].playing()) {
          state.audio[name].pause();
        } else {
          state.audio[name].play();
        }
      }
    }
  }
});

export default store;
